import useAuth from "hooks/useAuth";
import { ReactElement, createContext, useEffect } from "react";
import { dispatch } from "store";
import { load } from "store/reducers/form-data";
import { FormsContextType } from "types/form";
// import  axios from "utils/axios";

const FormsContext = createContext<FormsContextType | null>(null);

export const FormsProvider = ({ children }: { children: ReactElement }) => {
  const { user } = useAuth();
    
    useEffect(() => {
        const init = async () => {
          try {
            if(user){
              dispatch(load());
            }
          } catch (err) {
            console.error(err);
           
          }
        };
    
        init();
      }, []);
    return <FormsContext.Provider value={{  }}>{children}</FormsContext.Provider>;
}